import ajax from 'Site/js/util/ajax.fetch';
import { mapState } from 'vuex';

export default {
    computed: mapState({
        id: state => state.config.data.id,
        subscribed: state => state.config.data.subscribed
    }),
    methods: {
        toggleSubscribe() {
            let method = 'create';
            if (this.subscribed.id) {
                method = 'delete';
            }
            ajax[method](
                'subscribers',
                { id: this.subscribed.id, club: this.id }
            ).then((response) => {
                this.$store.dispatch('notify', { msg: response.message });
                this.subscribed.id = response.id;
            });
            this.subscribed.enabled = !this.subscribed.enabled;
        }
    }
};
